// components/SkeletonSkills.jsx
import Skeleton from "react-loading-skeleton";

const SkeletonSkills = () => {
  return (
    <section className="skill mt-8">
      <h3 className="h3 skills-title">
        <Skeleton width={100} height={20} />
      </h3>
      <ul className="skills-list content-card space-y-4 mt-4">
        {Array(4)
          .fill(null)
          .map((_, idx) => (
            <li className="skills-item" key={idx}>
              <div className="title-wrapper flex justify-between items-center mb-2">
                <Skeleton width={80} height={16} />
                <Skeleton width={40} height={16} />
              </div>
              <div className="skill-progress-bg h-2 rounded bg-gray-300 dark:bg-gray-700">
                <Skeleton height={8} borderRadius={4} />
              </div>
            </li>
          ))}
      </ul>
    </section>
  );
};

export default SkeletonSkills;
